import DeleteOrder from './DeleteOrder';

export default DeleteOrder;
